import React from 'react'
import RegexEscape from 'regex-escape';

import withParams from "components/hoc/withParams";

import { TITLE_CONTENTS } from "constant/search";

export default withParams(function Highlight({ __html = "", type, html, getParams }) {

    const { field = TITLE_CONTENTS, keyword = '' } = getParams();
    const fields = field.split(',');
    if (keyword.trim() && fields.indexOf(type) >= 0) {
        __html = __html.replace(new RegExp(RegexEscape(keyword.trim()), "gi"), '<b class="hl">$&</b>');
        return (
            <u dangerouslySetInnerHTML={{ __html }} />
        )
    } else if (html) {
        return <u dangerouslySetInnerHTML={{ __html }} />
    } else {
        return __html
    }
});
